<template>
  <div class="list">
    <s-header :linkto="linkto" :title="title"></s-header>
    <ul>
      <li v-for="(item, index) in list" :key="item.id">
        <router-link :to="'/a-detail?id=' + item.id" target="_blank">
          <img :src="list[0] ? list[0].path : ''" alt="" srcset="" v-if="imgIndex.includes(index)">
          <span v-else><span class="dot"></span>{{item.title}}</span>
        </router-link>
        </li>
    </ul>
  </div>
</template>

<script>
import SHeader from '../SHeader/Index.vue'
export default {
  name: 'CommonList',
  components: {
    SHeader
  },
  props: {
    linkto: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '推荐'
    },
    imgIndex: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang='less' scoped>
// 公共头
.list {
  width: 240px;
  ul {
    li {
      margin-top: 14px;
      padding-left: 14px;
      font-size: 14px;
      color:#222;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .dot {
        display: inline-block;
        width: 5px;
        height: 5px;
        background-color: #333;
        border-radius: 50%;
        margin-bottom: 2px;
        margin-right: 10px;
      }
    }
  }
}
a {
  color: #2c3e50;
  &:hover {
    text-decoration: underline;
  }
}
img {
  width: 100%;
  height: 146px;
  object-fit: cover;
  // margin: 20px 0;
}
</style>
